import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';

const styles = {
  card: {
    maxWidth: 345,
    margin: 'auto',
  },
  media: {
    objectFit: 'cover',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    position: 'absolute',
  },
  title: {
    height: 42,
  },
};

function TeamMemberCard({ classes, member, formatMessage }) {
  return (
    <Card className={classes.card}>
      <CardActionArea>
        <div style={{ paddingTop: '80%', width: '100%', position: 'relative' }}>
          <CardMedia
            component="img"
            alt={formatMessage('Image Not Available')}
            className={classes.media}
            image={member.imageUrl}
            title={formatMessage(member.name)}
          />
        </div>
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {formatMessage(member.name)}
          </Typography>
          <Typography component="p" className={classes.title}>
            {formatMessage(member.title)}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

TeamMemberCard.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  member: PropTypes.shape({}).isRequired,
  formatMessage: PropTypes.func.isRequired,
};

export default withStyles(styles)(TeamMemberCard);
